import Api from '~/api/wrapper-api'
import { DataProvider } from 'react-admin'
import {
  parserParamsForGetList,
  parserParamsForGetManyReference,
} from '~/utils/dataProviderParams'
import {
  CreateRole,
  Number,
  Response,
  ResponseArrayNumbers,
  ResponseArrayObjects,
  ResponseObject,
  String,
} from '~/utils/types'

export const rolesDataProvider: DataProvider = {
  async getList(resource: String, params): Promise<Response> {
    const filter = parserParamsForGetList(params, resource)
    const res = await Api.getList(resource, { ...filter })
    return { data: res.data.rows, total: res.data.count }
  },
  async getMany(
    resource: String,
    { ids }: { ids: ResponseArrayNumbers }
  ): Promise<ResponseArrayObjects> {
    const res = await Api.getList(resource, { filter: { id: ids } })
    return { data: res.data.rows }
  },
  async getManyReference(resource: String, params): Promise<Response> {
    const filter = parserParamsForGetManyReference(params, resource)
    const res = await Api.getList(resource, { ...filter })
    return { data: res.data.rows, total: res.data.count }
  },
  async getOne(
    resource: String,
    { id }: { id: Number }
  ): Promise<ResponseObject> {
    const [res] = (await Api.getWithQuery(resource, id)).data
    const properties = res.usersProperties.map(property => property.id)
    return { data: { ...res, properties } }
  },
  async create(
    resource: String,
    {
      data: { name, description, code, applicationId, isSystem, properties },
    }: { data: CreateRole }
  ): Promise<ResponseObject> {
    const res = await Api.create(resource, {
      name,
      description,
      code,
      applicationId,
      isSystem,
      properties,
    })
    return { data: res.data }
  },
  async update(
    resource: String,
    {
      data: {
        id,
        name,
        description,
        code,
        applicationId,
        isSystem,
        properties,
      },
    }
  ): Promise<ResponseObject> {
    const res = await Api.update(resource, id, {
      name,
      description,
      code,
      applicationId,
      isSystem,
      properties,
    })
    return { data: res.data }
  },
  async updateMany(resource: String, params): Promise<ResponseObject> {
    console.log('🚧 UpdateMany:', resource, '\n', params)
    return { data: undefined }
  },
  async delete(
    resource: String,
    { id }: { id: Number }
  ): Promise<ResponseObject> {
    const res = await Api.delete(resource, id)
    return { data: res.data.rows }
  },
  async deleteMany(resource: String, params): Promise<ResponseObject> {
    console.log('🚧 deleteMany:', resource, '\n', params)
    return { data: undefined }
  },
}
